export default __webpack_public_path__ + "static/media/frame3.c144bd53.jpg";